<template>
  <div>
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="left flex-between">
                <div
                  class="title-control flex-between"
                  @click="showHandleData = !showHandleData"
                >
                  <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "Filed Service Order" : "外派工单" }}({{
                    orderData.countExpatriateOrder
                  }})
                </p>
                <span></span>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-collapse-transition>
          <div class="wrap" v-if="showHandleData">
            <div class="card">
              <div class="add_title">
                <div>
                  <!-- <span class="title">创建外派工单</span> -->
                  <el-button
                    style="min-width: 150px"
                    v-if="isHandleV2"
                    size="mini"
                    icon="el-icon-plus"
                    @click="openAdd"
                    >{{
                      $lange == "en" ? "Create a new order" : "添加工程师"
                    }}</el-button
                  >
                </div>
                <div
                  :class="
                    'user_select ' + ($lange == 'en' ? 'user_select2' : '')
                  "
                  v-if="isHandleV2"
                >
                  <span>{{
                    $lange == "en" ? "Responsible:" : "处理人："
                  }}</span>
                  <el-select
                    v-model="fromData.handlerId"
                    placeholder=""
                    size="mini"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in userSelectorList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="new_wrap">
                <div class="new_wrap_left">
                  <div class="table">
                    <cc-table
                      :config="addTable"
                      :data-arr="expatriatePlanList"
                      :load-data="false"
                    ></cc-table>
                  </div>
                </div>
                <div class="new_wrap_right" v-if="isHandleV2">
                  <div class="new_wrap_right_button">
                    <el-button
                      size="mini"
                      type="primary"
                      style="width: 100%"
                      @click="save(1)"
                      >{{ $lange == "en" ? "Submit" : "提交" }}</el-button
                    >
                  </div>
                  <div class="new_wrap_right_button">
                    <el-button
                      size="mini"
                      style="width: 100%"
                      @click="saveHold(0)"
                      >{{
                        $lange == "en" ? "Save as a draft" : "保存草稿"
                      }}</el-button
                    >
                  </div>
                  <div class="new_wrap_right_button">
                    <el-button
                      size="mini"
                      style="width: 100%"
                      @click="openUploaderDialog = true"
                      >{{
                        $lange == "en" ? "Attachment" : "上传附件"
                      }}</el-button
                    >
                  </div>
                </div>
              </div>
              <div class="file">
                <div>
                  <span>{{ $lange == "en" ? "Attachment" : "附件" }}：</span>
                </div>
                <div class="file_img">
                  <div v-if="fromData.accessoryInfoList.length == 0">
                    {{ $lange == "en" ? "Null" : "无" }}
                  </div>
                  <div
                    class="img_list"
                    v-for="(img, index) in fromData.accessoryInfoList"
                  >
                    <el-image
                      :key="index"
                      class="img"
                      :src="img.accessoryUrl"
                      fit="fit"
                      @click="showImage(img.accessoryUrl)"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i></div
                    ></el-image>
                    <div
                      class="del-image flex-between"
                      @click.stop="deleteImage(ind)"
                    >
                      X
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="order_mountings_list_wrap">
              <div class="order_mountings_list_card">
                <!-- <div class="box-card" shadow="never">
                  <div class="title" >
                    <span>关联的外派工单列表</span>
                  </div>
                </div> -->
                <cc-table
                  :title="
                    $lange == 'en' ? 'Existing Filed Service Order' : '已有申请'
                  "
                  :config="listTableConfig"
                  :refesh-params="listTablereferTableConfig"
                ></cc-table>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <el-dialog :visible.sync="showImageFlag" width="80%" append-to-body>
      <img
        :src="nowShowImageUrl"
        style="display: block; margin: 0 auto; width: 100%"
        alt
      />
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? 'Create a Job Order' : '添加外派需求'"
      :visible.sync="addPartsFlag"
      width="90%"
      append-to-body
    >
      <template v-if="addPartsFlag">
        <el-form
          :model="editData"
          :rules="rules"
          ref="ruleForm"
          :label-width="$lange == 'en' ? '140px' : '120px'"
          class="demo-ruleForm"
        >
          <el-form-item
            :label="$lange == 'en' ? 'Cost Type' : '费用类型:'"
            prop="feeType"
            required
          >
            <el-select v-model="editData.feeType" placeholder="" size="small">
              <el-option :label="$lange == 'en' ? 'Free' : '保内'" :value="0">{{
                $lange == "en" ? "Free" : "保内"
              }}</el-option>
              <el-option :label="$lange == 'en' ? 'Paid' : '保外'" :value="1">{{
                $lange == "en" ? "Paid" : "保外"
              }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'Planned From' : '预计开始时间:'"
            required
            prop="startTime"
          >
            <el-date-picker
              type="date"
              placeholder=""
              v-model="editData.startTime"
              size="small"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType1"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Mechanic" : "机械工程师" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType1.num"
                style="width: 100px; margin-right: 20px"
                :min="0.1"
                @input="changeNum"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType1.preWorkHour"
                style="width: 100px; margin-right: 20px"
                @input="changePreWorkHour"
                :min="0.1"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType1.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType2"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Electrical" : "电气工程师" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType2.num"
                style="width: 100px; margin-right: 20px"
                @input="changeNum"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType2.preWorkHour"
                @input="changePreWorkHour"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType2.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType3"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Software" : "软件工程师" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType3.num"
                style="width: 100px; margin-right: 20px"
                @input="changeNum"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType3.preWorkHour"
                @input="changePreWorkHour"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType3.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            :label="$lange == 'en' ? 'Engineer Category:' : '工程师类型:'"
            prop="employeeType4"
          >
            <div class="input">
              <span>{{ $lange == "en" ? "Quality" : "质量工程师:" }}</span>
              <span>{{
                $lange == "en" ? "Number of engineer:" : "预计人数:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType4.num"
                @input="changeNum"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{
                $lange == "en" ? "Estimated Working Hours:" : "预计总工时:"
              }}</span>
              <el-input
                size="small"
                type="number"
                v-model="editData.employeeType4.preWorkHour"
                @input="changePreWorkHour"
                style="width: 100px; margin-right: 20px"
              ></el-input>
              <span>{{ $lange == "en" ? "Remark:" : "备注:" }}</span>
              <el-input
                size="small"
                v-model="editData.employeeType4.remark"
                style="width: 300px"
              ></el-input>
            </div>
          </el-form-item>

          <div class="button_wrap">
            <el-button @click="addPartsFlag = false" size="mini">{{
              $lange == "en" ? "Cancel" : "取消"
            }}</el-button>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              size="mini"
              >{{ $lange == "en" ? "Save" : "确认添加" }}</el-button
            >
          </div>
        </el-form>
      </template>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="openUploaderDialog"
      width="30%"
      append-to-body
    >
      <template v-if="openUploaderDialog">
        <div class="uploader">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedMultiple"
            @upload-success="uploadTrue"
            :isMultiple="false"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    orderData: Object,
    isHandleV2: Boolean,
  },
  data() {
    return {
      userSelectorList: [],
      showHandleData: true,
      showImageFlag: false,
      nowShowImageUrl: "",
      addTable: {
        columns: [
          {
            prop: "employeeType",
            lable: this.$lange == "en" ? "Engineer Category" : "工程师类别",
            minWidth: 120,
            render: (row) => {
              // return ["机械工程师", "电气工程师", "软件工程师", "质量工程师"][
              //   row.employeeType
              // ];
              if (this.$lange == "en") {
                return ["Mechanic", "Electrical", "Software", "Quality"][
                  row.employeeType
                ];
              } else {
                return ["机械工程师", "电气工程师", "软件工程师", "质量工程师"][
                  row.employeeType
                ];
              }
            },
          },
          {
            prop: "num",
            lable: this.$lange == "en" ? "Quantity" : "人数",
            minWidth: 80,
          },
          {
            prop: "preWorkHour",
            lable: this.$lange == "en" ? "Total working hours" : "预计总工时",
            minWidth: 100,
          },
          {
            prop: "startTime",
            lable: this.$lange == "en" ? "Planned from" : "计划开始",
            minWidth: 100,
          },
          {
            prop: "feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型:",
            minWidth: 80,
            // render: (row) => {
            //   if (this.$lange != "en") {
            //     return ["保内", "保外"][row.feeType];
            //   } else {
            //     return ["Free", "Paid"][row.feeType];
            //   }
            // },
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Free" : "保内",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Paid" : "保外",
              },
            ],
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            minWidth: 150,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Delete" : "移除",
            click: (row, $index) => {
              this.$confirm("此操作会移除该外派工单", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.expatriatePlanList.splice($index, 1);
                })
                .catch(() => {});
            },
            check: (row) => {
              return this.isHandleV2;
            },
          },
          {
            name: this.$lange == "en" ? "Edit" : "修改",
            click: (row, $index) => {
              // let editData = {
              //   employeeType1: {
              //     num: "",
              //     preWorkHour: "",
              //     remark: "",
              //   },
              //   employeeType2: {
              //     num: "",
              //     preWorkHour: "",
              //     remark: "",
              //   },
              //   startTime: this.editData.startTime,
              //   feeType: this.editData.feeType,
              // };
              // if (this.editData.employeeType1.num) {
              //   editData.employeeType1 = {};
              //   editData.employeeType1 = {
              //     num: this.editData.employeeType1.num,
              //     preWorkHour: this.editData.employeeType1.preWorkHour,
              //     remark: this.editData.employeeType1.remark,
              //   };
              // }
              // if (this.editData.employeeType2.num) {
              //   editData.employeeType2 = {};
              //   editData.employeeType2 = {
              //     num: this.editData.employeeType2.num,
              //     preWorkHour: this.editData.employeeType2.preWorkHour,
              //     remark: this.editData.employeeType2.remark,
              //   };
              // }
              // this.editData = editData;

              let editData = {
                employeeType1: {
                  num: "",
                  preWorkHour: "",
                  remark: "",
                },
                employeeType2: {
                  num: "",
                  preWorkHour: "",
                  remark: "",
                },
                employeeType3: {
                  num: "",
                  preWorkHour: "",
                  remark: "",
                },
                employeeType4: {
                  num: "",
                  preWorkHour: "",
                  remark: "",
                },
                startTime: this.expatriatePlanList[0].startTime,
                // feeType: this.expatriateData.feeType,
                feeType: this.expatriatePlanList[0].feeType,
              };
              let expatriatePlanList = this.expatriatePlanList;
              for (let index = 0; index < expatriatePlanList.length; index++) {
                if (expatriatePlanList[index].employeeType == 0) {
                  editData.employeeType1 = {
                    ...expatriatePlanList[index],
                  };
                } else if (expatriatePlanList[index].employeeType == 1) {
                  editData.employeeType2 = {
                    ...expatriatePlanList[index],
                  };
                } else if (expatriatePlanList[index].employeeType == 2) {
                  editData.employeeType3 = {
                    ...expatriatePlanList[index],
                  };
                } else if (expatriatePlanList[index].employeeType == 3) {
                  editData.employeeType4 = {
                    ...expatriatePlanList[index],
                  };
                }
              }
              console.log(editData);
              this.editData = editData;

              console.log(editData, this.editData);
              this.addPartsFlag = true;
            },
            check: (row) => {
              return this.isHandleV2;
            },
          },
        ],
      },
      listTableConfig: {
        api:
          "admin/fsb/expatriate/queryByPlan?workOrderId=" + this.orderData.id,
        showPager: true,

        columns: [
          {
            prop: "expatriateOrder.id",
            lable: this.$lange == "en" ? "Order No." : "订单号",
            minWidth: 90,
          },
          {
            prop: "expatriateOrder.status",
            lable: this.$lange == "en" ? "Status" : "订单状态",
            minWidth: 90,
            render: (e) => {
              let type = [
                {
                  label: "草稿",
                  value: 0,
                },
                {
                  label: this.$lange == "en" ? "New" : "新申请",
                  value: 1,
                },
                {
                  label: this.$lange == "en" ? "Customer Action" : "待客户确认",
                  value: 2,
                },
                {
                  label: this.$lange == "en" ? "Waiting Approval" : "待审批",
                  value: 3,
                },
                {
                  label:
                    this.$lange == "en" ? "Engineer Preparing" : "等待派工",
                  value: 4,
                },
                {
                  label: this.$lange == "en" ? "On working" : "服务中",
                  value: 5,
                },
                {
                  label: this.$lange == "en" ? "Completed" : "已完成",
                  value: 6,
                },
                {
                  label: this.$lange == "en" ? "Close" : "已关闭",
                  value: 7,
                },
                {
                  label: this.$lange == "en" ? "Cancel" : "已取消",
                  value: 8,
                },
              ];
              return type[e.expatriateOrder.status].label;
            },
          },
          // {
          //   prop: "expatriateOrder.workOrder.jobId",
          //   lable: "Job ID",
          //   minWidth: 100,
          // },
          {
            prop: "employeeType",
            lable: this.$lange == "en" ? "Engineer Category" : "工程师类别",
            minWidth: 90,
            render: (row) => {
              if (this.$lange == "en") {
                return ["Mechanic", "Electrical", "Software", "Quality"][
                  row.employeeType
                ];
              } else {
                return ["机械工程师", "电气工程师", "软件工程师", "质量工程师"][
                  row.employeeType
                ];
              }
            },
          },
          {
            prop: "num",
            lable: this.$lange == "en" ? "Quantity" : "数量",
            minWidth: 50,
          },
          {
            prop: "preWorkHour",
            lable: this.$lange == "en" ? "Plan Working" : "预计总工时",
            minWidth: 80,
          },
          {
            prop: "expatriateOrder.feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型",
            minWidth: 70,
            // render: (row) => {
            //   // return ["保内", "保外"][row.expatriateOrder.feeType];
            //   if (this.$lange != "en") {
            //     return ["保内", "保外"][row.expatriateOrder.feeType];
            //   } else {
            //     return ["Free", "Paid"][row.expatriateOrder.feeType];
            //   }
            // },
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Free" : "保内",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Paid" : "保外",
              },
            ],
          },

          {
            prop: "expatriateOrder.handlerName",
            lable: this.$lange == "en" ? "Responsible" : "处理人",
            minWidth: 100,
          },
          {
            prop: "startTime",
            lable: this.$lange == "en" ? "Scheduled to go" : "计划开始",
            minWidth: 90,
            render: (row) => {
              if (row.startTime) {
                return moment(row.startTime).format("YYYY-MM-DD");
              }
            },
          },
          // {
          //   prop: "endTime",
          //   lable: "计划结束",
          //   minWidth: 100,
          //   render: (row) => {
          //     if (row.endTime) {
          //       return moment(row.endTime).format("YYYY-MM-DD");
          //     }
          //   },
          // },
          {
            prop: "relStartTime",
            lable: this.$lange == "en" ? "Actual Start" : "实际开始",
            minWidth: 100,
            render: (row) => {
              if (row.relStartTime) {
                return moment(row.relStartTime).format("YYYY-MM-DD");
              }
            },
          },
          // {
          //   prop: "relEndTime",
          //   lable: "实际结束",
          //   minWidth: 100,
          //   render: (row) => {
          //     if (row.relEndTime) {
          //       return moment(row.relEndTime).format("YYYY-MM-DD");
          //     }
          //   },
          // },
          // {
          //   prop: "expatriateOrder.workOrder.customer.customerName",
          //   lable: "公司",
          //   minWidth: 100,
          // },
          // {
          //   prop: "expatriateOrder.adminName",
          //   lable: "申请人",
          //   minWidth: 100,
          // },
          {
            prop: "expatriateOrder.createTime",
            lable: this.$lange == "en" ? "Create at" : "创建时间",
            minWidth: 140,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View" : "查看",
            click: (row, $index) => {
              // console.log(row.expatriateOrderId)
              // if (this.isHandleV2) {
              //   this.newWindow({
              //     url:
              //       "/admin/order/expatriate/des?id=" +
              //       row.expatriateOrderId +
              //       "&isEdit=" +
              //       this.isHandleV2,
              //     name: "外派工单详情",
              //   });
              // } else {
              this.newWindow({
                url: "/admin/order/expatriate/des?id=" + row.expatriateOrderId,
                name: "外派工单详情",
              });
              // }
            },
            // check: (row) => {
            //   return this.isHandleV2;
            // },
          },
        ],
      },
      listTablereferTableConfig: -1,
      fromData: {
        handlerId: "",
        // employeeType1: {},
        // employeeType2: {},
        accessoryInfoList: [],
      },
      editData: {
        employeeType1: {},
        employeeType2: {},
      },
      addPartsFlag: false,
      rules: {
        feeType: [{ required: true, message: "不可为空", trigger: "blur" }],
        startTime: [{ required: true, message: "不可为空", trigger: "blur" }],
      },
      expatriatePlanList: [],
      openUploaderDialog: false,
      uploaderConf2: this.$uploadUtils.config, //文件上传需要
    };
  },
  watch: {
    orderData: {
      handler() {
        if (this.orderData.draftExpatriateOrder) {
          this.expatriatePlanList =
            this.orderData.draftExpatriateOrder.expatriatePlanList;
          for (let index = 0; index < this.expatriatePlanList.length; index++) {
            this.expatriatePlanList[index].feeType =
              this.orderData.draftExpatriateOrder.feeType;
          }
          // let editData = {
          //   employeeType1: {},
          //   employeeType2: {},
          //   startTime: this.expatriatePlanList[0].startTime,
          //   feeType: this.expatriatePlanList[0].feeType || this.orderData.draftExpatriateOrder.feeType,
          // };
          // for (let index = 0; index < this.expatriatePlanList.length; index++) {
          //   this.expatriatePlanList[index].feeType =
          //     this.orderData.draftExpatriateOrder.feeType;
          //   if (this.expatriatePlanList[index].employeeType == 0) {
          //     editData.employeeType1 = {
          //       num: this.expatriatePlanList[index].num,
          //       preWorkHour: this.expatriatePlanList[index].preWorkHour,
          //       remark: this.expatriatePlanList[index].remark,
          //     };
          //   } else {
          //     editData.employeeType2 = {
          //       num: this.expatriatePlanList[index].num,
          //       preWorkHour: this.expatriatePlanList[index].preWorkHour,
          //       remark: this.expatriatePlanList[index].remark,
          //     };
          //   }
          //   this.editData = editData;
          // }
          if (this.orderData.draftExpatriateOrder.id) {
            this.fromData.id = this.orderData.draftExpatriateOrder.id;
          }
          this.fromData.handlerId =
            this.orderData.draftExpatriateOrder.handlerId * 1;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changeNum(e) {
      console.log(e);
      if (e.indexOf(".") > -1) {
        this.$message.error("预计人数请填大于0的整数");
        return false;
      }
    },
    changePreWorkHour(e) {
      if (e < 0) {
        this.$message.error("预计总工时请填大于0的整数");
        return false;
      }
    },
    getUserList() {
      let api = `admin/fsb/work/order/queryHandlerUser?pageSize=999&isAsc=true`;
      this.ccRequest
        .do(api, ["accessoriesSpecialist"], "POSTJSON")
        .then((res) => {
          this.userSelectorList = res;
          if (this.fromData.handlerId == "") {
            this.fromData.handlerId = res[0].id;
          }
        });
    },
    showImage(url) {
      this.nowShowImageUrl = url;
      this.showImageFlag = true;
    },
    openAdd() {
      this.editData = {
        employeeType1: {
          num: "",
          preWorkHour: "",
          remark: "",
        },
        employeeType2: {
          num: "",
          preWorkHour: "",
          remark: "",
        },
        employeeType3: {
          num: "",
          preWorkHour: "",
          remark: "",
        },
        employeeType4: {
          num: "",
          preWorkHour: "",
          remark: "",
        },
      };
      this.addPartsFlag = true;
    },
    uploadTrue(res) {
      console.log(res, "uploadTrue");
      this.fromData.accessoryInfoList.push(res);
      this.$message({
        type: "success",
        message: "上传成功",
      });
      this.openUploaderDialog = false;
    },
    deleteImage(idx) {
      this.fromData.accessoryInfoList.splice(idx, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.fromData);
          if (
            this.editData.employeeType1.num ||
            this.editData.employeeType1.preWorkHour ||
            this.editData.employeeType1.remark
          ) {
            if (
              this.editData.employeeType1.num === "" ||
              this.editData.employeeType1.preWorkHour === ""
            ) {
              this.$message.error("请完善机械工程师数据");
              return false;
            }
          } else if (
            this.editData.employeeType2.num ||
            this.editData.employeeType2.preWorkHour ||
            this.editData.employeeType2.remark
          ) {
            if (
              this.editData.employeeType2.num === "" ||
              this.editData.employeeType2.preWorkHour === ""
            ) {
              this.$message.error("请完善电气工程师数据");
              return false;
            }
          } else if (
            this.editData.employeeType3.num ||
            this.editData.employeeType3.preWorkHour ||
            this.editData.employeeType3.remark
          ) {
            if (
              this.editData.employeeType3.num === "" ||
              this.editData.employeeType3.preWorkHour === ""
            ) {
              this.$message.error("请完善软件工程师数据");
              return false;
            }
          } else if (
            this.editData.employeeType4.num ||
            this.editData.employeeType4.preWorkHour ||
            this.editData.employeeType4.remark
          ) {
            if (
              this.editData.employeeType4.num === "" ||
              this.editData.employeeType4.preWorkHour === ""
            ) {
              this.$message.error("请完善质量工程师数据");
              return false;
            }
          }

          if (
            this.editData.employeeType4.num === "" &&
            this.editData.employeeType4.preWorkHour === "" &&
            this.editData.employeeType3.num === "" &&
            this.editData.employeeType3.preWorkHour === "" &&
            this.editData.employeeType2.num === "" &&
            this.editData.employeeType2.preWorkHour === "" &&
            this.editData.employeeType1.num === "" &&
            this.editData.employeeType1.preWorkHour === ""
          ) {
            this.$message.error("最少输入一种工程数据");
            return false;
          }

          let expatriatePlanList = [];
          if (
            this.editData.employeeType1.num &&
            this.editData.employeeType1.preWorkHour
          ) {
            expatriatePlanList.push({
              ...this.editData.employeeType1,
              startTime: this.editData.startTime,
              employeeType: 0,
              feeType: this.editData.feeType,
            });
          }

          if (
            this.editData.employeeType2.num &&
            this.editData.employeeType2.preWorkHour
          ) {
            expatriatePlanList.push({
              ...this.editData.employeeType2,
              startTime: this.editData.startTime,
              employeeType: 1,
              feeType: this.editData.feeType,
            });
          }

          if (
            this.editData.employeeType3.num &&
            this.editData.employeeType3.preWorkHour
          ) {
            expatriatePlanList.push({
              ...this.editData.employeeType3,
              startTime: this.editData.startTime,
              employeeType: 2,
              feeType: this.editData.feeType,
            });
          }

          if (
            this.editData.employeeType4.num &&
            this.editData.employeeType4.preWorkHour
          ) {
            expatriatePlanList.push({
              ...this.editData.employeeType4,
              startTime: this.editData.startTime,
              employeeType: 3,
              feeType: this.editData.feeType,
            });
          }

          let employeeType1Num = this.editData.employeeType1.num + "";
          let employeeType2Num = this.editData.employeeType2.num + "";
          let employeeType3Num = this.editData.employeeType3.num + "";
          let employeeType4Num = this.editData.employeeType4.num + "";
          if (
            this.editData.employeeType1.num &&
            (employeeType1Num.indexOf(".") > -1 || employeeType1Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType2.num &&
            (employeeType2Num.indexOf(".") > -1 || employeeType2Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType3.num &&
            (employeeType3Num.indexOf(".") > -1 || employeeType3Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType4.num &&
            (employeeType4Num.indexOf(".") > -1 || employeeType4Num <= 0)
          ) {
            this.$message.error("预计人数请填大于0的整数");
            return false;
          }

          let employeeType1PreWorkHour =
            this.editData.employeeType1.preWorkHour + "";
          let employeeType2PreWorkHour =
            this.editData.employeeType2.preWorkHour + "";
          let employeeType3PreWorkHour =
            this.editData.employeeType3.preWorkHour + "";
          let employeeType4PreWorkHour =
            this.editData.employeeType4.preWorkHour + "";
          if (
            this.editData.employeeType1.preWorkHour &&
            employeeType1PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType2.preWorkHour &&
            employeeType2PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType3.preWorkHour &&
            employeeType3PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }
          if (
            this.editData.employeeType4.preWorkHour &&
            employeeType4PreWorkHour <= 0
          ) {
            this.$message.error("预计总工时请填大于0的整数");
            return false;
          }

          this.expatriatePlanList = [...expatriatePlanList];
          this.addPartsFlag = false;
          console.log(expatriatePlanList);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    save(status) {
      if (!this.fromData.handlerId) {
        this.$message.error("请选择处理人");
        return false;
      } else if (this.expatriatePlanList.length == 0) {
        this.$message.error("请添加工程师");
        return false;
      }
      let from = {
        // id: "1000186011",
        // appId: "fosber",
        status: status,
        workOrderId: this.orderData.id,
        startTime: this.editData.startTime,
        feeType: this.editData.feeType,
        handlerId: this.fromData.handlerId,
        expatriatePlanList: [...this.expatriatePlanList],
        id: this.fromData.id || "",
      };
      console.log(from);
      this.$confirm("确定提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do(
              "admin/fsb/work/order/log/saveExpatriateOrder",
              from,
              "POSTJSON"
            )
            .then((res) => {
              if (status == 1) {
                this.expatriatePlanList = [];
                this.fromData.handlerId = "";
                this.listTablereferTableConfig = new Date().getTime();
              } else {
                // this.$emit("updateOrder", [
                //   "draftExpatriateOrder",
                //   "remarkList",
                //   "countExpatriateOrder",
                //   "isHandle",
                // ]);
              }
              this.$emit("updateOrder", true);
              this.$message({
                type: "success",
                message: "操作成功",
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },
    saveHold(status) {
      if (!this.fromData.handlerId) {
        this.$message.error("请选择处理人");
        return false;
      } else if (this.expatriatePlanList.length == 0) {
        this.$message.error("请添加工程师");
        return false;
      }
      let from = {
        // id: "1000186011",
        // appId: "fosber",
        status: status,
        workOrderId: this.orderData.id,
        startTime: this.editData.startTime,
        feeType: this.editData.feeType,
        handlerId: this.fromData.handlerId,
        expatriatePlanList: [...this.expatriatePlanList],
        id: this.fromData.id || "",
      };
      console.log(from);
      // this.$confirm("确定提交吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      this.ccRequest
        .do("admin/fsb/work/order/log/saveExpatriateOrder", from, "POSTJSON")
        .then((res) => {
          if (status == 1) {
            this.expatriatePlanList = [];
            this.fromData.handlerId = "";
            this.fromData.id = "";
            this.listTablereferTableConfig = new Date().getTime();
          } else {
            this.$emit("updateOrder", [
              "draftExpatriateOrder",
              "remarkList",
              "countExpatriateOrder",
              "isHandle",
            ]);
          }
          this.$message({
            type: "success",
            message: "操作成功",
          });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
      // })
      // .catch((err) => {
      //   console.log(err);
      //   this.$message.error(err.response.data.message);
      // });
    },
  },
  mounted() {
    this.getUserList();
  },
};
</script>
<style scoped lang="scss">
.order-solution {
  background: #ffffff;
  margin-top: 5px;

  .os-list {
    padding: 20px;
    border-bottom: 10px solid #f3f3f4;
    // border-bottom: 1px dotted #ccc;
    // border-top: 5px solid #f3f3f4;
    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }
  }
}
.li_wrap {
  margin-top: 20px;
  .li {
    margin-bottom: 20px;
  }
}

.wrap {
  .card {
    margin-top: 20px;
    padding: 30px 20px 20px 20px;
    background: rgb(245, 247, 250);
  }
  .add_title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    span {
      margin-right: 20px;
    }
    .user_select {
      display: flex;
      align-items: center;
      // width: 270px;
      width: 220px;
      span {
        min-width: 70px;
        margin-right: 0px;
      }
    }
    .user_select2 {
      width: 240px;
      span {
        min-width: 90px;
      }
    }
  }
  .new_wrap {
    display: flex;
    justify-content: space-between;
    .new_wrap_left {
      width: 100%;
      margin-right: 20px;
      .table {
        // max-width: 700px;
        width: 80%;
      }
    }
    .new_wrap_right {
      // min-width: 200px;
      min-width: 150px;
      .new_wrap_right_button {
        width: 100%;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        font-weight: bold;
        span {
          min-width: 70px;
        }
      }
    }
  }
  .file {
    margin-top: 20px;
    display: flex;
    padding-bottom: 30px;
  }
  .file_img {
    display: flex;
    .img_list {
      position: relative;
    }
    .img {
      width: 50px;
      height: 50px;
      margin: 0 10px;
    }
    .del-image {
      width: 20px;
      height: 20px;
      line-height: 0;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      border: 1px solid #f00;
      color: #f00;
      font-size: 14px;
      border-radius: 50%;
      transform: translateX(0%) translateY(-50%);
      cursor: pointer;
    }
  }
  .order_mountings_list_wrap {
    .order_mountings_list_card {
      background: #fff;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
.input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    margin: 0 10px;
  }
  input {
    margin-right: 20px;
  }
}
.button_wrap {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.uploader {
  position: relative;
  height: 200px;
}
</style>
<style lang="scss">
.order_mountings_list_card {
  background: #fff;
  .clearfix {
    font-size: 16px;
    font-weight: bold;
  }
}
.image-slot {
  width: 100%;
  height: 100%;
  background: #dbdddf;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>